/*
 * Project: bellcloud
 * File: packages/types/device/mini/sensors.ts
 * Author: SWAN
 * Created: 2025-01-27
 * Description: Mini device sensor types
 */

export enum MiniSensorType {
  CO = 0,
  O2 = 1,
  H2 = 2,
  H2S = 3,
  NH3 = 4,
  Cl2 = 5,
  SO2 = 6,
  NO2 = 7,
  HCN = 8,
  PH3 = 9,
  ETO = 10,
  O3 = 11,
  HCl = 12,
  NO = 13,
  NH3_E = 14,
  O2_LF = 15,
  CO_H = 16,
  CH2O2 = 17,
  CO_E = 18,
  CO2 = 19,
  NO_SENSOR = 255,
}

export type MiniSensorTypeInfo = {
  index: number;
  label: string;
};

export const MINI_SENSOR_TYPE_INFO: Record<MiniSensorType, MiniSensorTypeInfo> = {
  [MiniSensorType.CO]: {
    index: 0,
    label: 'CO',
  },
  [MiniSensorType.O2]: {
    index: 1,
    label: 'O2',
  },
  [MiniSensorType.H2]: {
    index: 2,
    label: 'H2',
  },
  [MiniSensorType.H2S]: {
    index: 3,
    label: 'H2S',
  },
  [MiniSensorType.NH3]: {
    index: 4,
    label: 'NH3',
  },
  [MiniSensorType.Cl2]: {
    index: 5,
    label: 'Cl2',
  },
  [MiniSensorType.SO2]: {
    index: 6,
    label: 'SO2',
  },
  [MiniSensorType.NO2]: {
    index: 7,
    label: 'NO2',
  },
  [MiniSensorType.HCN]: {
    index: 8,
    label: 'HCN',
  },
  [MiniSensorType.PH3]: {
    index: 9,
    label: 'PH3',
  },
  [MiniSensorType.ETO]: {
    index: 10,
    label: 'ETO',
  },
  [MiniSensorType.O3]: {
    index: 11,
    label: 'O3',
  },
  [MiniSensorType.HCl]: {
    index: 12,
    label: 'HCl',
  },
  [MiniSensorType.NO]: {
    index: 13,
    label: 'NO',
  },
  [MiniSensorType.NH3_E]: {
    index: 14,
    label: 'NH3-E',
  },
  [MiniSensorType.O2_LF]: {
    index: 15,
    label: 'O2',
  },
  [MiniSensorType.CO_H]: {
    index: 16,
    label: 'CO-H',
  },
  [MiniSensorType.CH2O2]: {
    index: 17,
    label: 'CH2O2',
  },
  [MiniSensorType.CO_E]: {
    index: 18,
    label: 'CO-E',
  },
  [MiniSensorType.CO2]: {
    index: 19,
    label: 'CO2',
  },
  [MiniSensorType.NO_SENSOR]: {
    index: -1,
    label: '-',
  },
};

export const getMiniSensorTypeInfo = (sensorType: MiniSensorType): MiniSensorTypeInfo => {
  return MINI_SENSOR_TYPE_INFO[sensorType] ?? { index: -1, label: '-' };
};

// 문자열을 MiniSensorType으로 변환하는 매핑
export const MINI_SENSOR_TYPE_MAP: Record<string, MiniSensorType> = {
  CO: MiniSensorType.CO,
  O2: MiniSensorType.O2,
  H2: MiniSensorType.H2,
  H2S: MiniSensorType.H2S,
  NH3: MiniSensorType.NH3,
  Cl2: MiniSensorType.Cl2,
  SO2: MiniSensorType.SO2,
  NO2: MiniSensorType.NO2,
  HCN: MiniSensorType.HCN,
  PH3: MiniSensorType.PH3,
  ETO: MiniSensorType.ETO,
  O3: MiniSensorType.O3,
  HCl: MiniSensorType.HCl,
  NO: MiniSensorType.NO,
  'NH3-E': MiniSensorType.NH3_E,
  'O2-LF': MiniSensorType.O2_LF,
  'CO-H': MiniSensorType.CO_H,
  CH2O2: MiniSensorType.CH2O2,
  'CO-E': MiniSensorType.CO_E,
  CO2: MiniSensorType.CO2,
};
